import { createContext } from 'react';
import { IScheduleContextState } from './types';

export const ScheduleContext = createContext<IScheduleContextState | undefined>(undefined);
